/** @format */
import {
  createQueryKeys,
  mergeQueryKeys,
} from "@lukemorales/query-key-factory";
import { QUERY_KEYS } from "../../constant/queryKeys.constant";

const companyQueryKeys = createQueryKeys(QUERY_KEYS.company, {
  getCompanyByID: (company_id) => ["company_id", company_id],
});

const skillQueryKeys = createQueryKeys(QUERY_KEYS.skill, {
  getSkillByUserID: (user_id) => ["user_id", user_id],
});

const experienceQueryKeys = createQueryKeys(QUERY_KEYS.experience, {
  getExperienceByUserID: (user_id) => ["user_id", user_id],
});

const educationQueryKeys = createQueryKeys(QUERY_KEYS.education, {
  getEducationByUserID: (user_id) => ["user_id", user_id],
});

export const queryKeys = mergeQueryKeys(
  companyQueryKeys,
  skillQueryKeys,
  experienceQueryKeys,
  educationQueryKeys
);
